type ThrottledFunction<T extends (...args: any[]) => any> = (
  ...args: Parameters<T>
) => void;

//  to limit how often 'func' can be called within a 'limit' period
export const throttle = <T extends (...args: any[]) => any>(
  func: T,
  limit: number,
): ThrottledFunction<T> => {
  let lastFunc: NodeJS.Timeout;
  let lastRan: number;

  return function (...args: Parameters<T>) {
    if (!lastRan) {
      func(...args); // Call immediately if it's the first time
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc); // Reset the timeout if the function is called again
      lastFunc = setTimeout(
        () => {
          if (Date.now() - lastRan >= limit) {
            func(...args); // Call after 'limit' time has passed
            lastRan = Date.now();
          }
        },
        limit - (Date.now() - lastRan),
      );
    }
  };
};
